import { HttpClient } from "@angular/common/http";
import { Endpoints } from "src/app/shared/config/endpoints";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/app.state";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FacebookService {
  private orgId: number;
  private userId: number;
  private userName: string;
  private userRole: string;
  private baseUri = this.endpoints.facebookServiceUrl;

  postToView = new BehaviorSubject<any>({});
  postToReply: any = new BehaviorSubject<any>({});
  repliedPost: any = new BehaviorSubject<string>("");
  postModalReady$ = new Subject<void>();
  department: any;

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      if (info && info.organization) {
        this.orgId = info.organization.id;
      }
      if (info && info.user) {
        this.userId = info.user.id;
        this.userName = `${info.user.firstName || ''} ${info.user.lastName || ''}`.trim();
      }
      this.userRole = info && info.roleName === 'Super Admin'
        ? 'ADMIN'
        : info && info.supervisor
          ? 'SUPERVISOR'
          : 'AGENT';
    });
    this.department = JSON.parse(localStorage.getItem("departmentInfo"));
  }

  fetchOrganizationPages(department): Observable<any> {
    if(department && department.id){
      return this.http.get(`${this.baseUri}/pages/${this.orgId}/${department.id}`);
    } else {
      return this.http.get(`${this.baseUri}/pages/${this.orgId}`);
    }
  }

  login(code: string, departmentID: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/setup/connect`, {
      code,
      org_id: this.orgId,
      department_id: departmentID
    });
  }

  subscribeToApp(data: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/setup/subscribe`, {
      org_id: this.orgId,
      ...data,
    });
  }

  fetchPageSubscriptions(pageId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/pages/setup/subscriptions/${this.orgId}/${pageId}`
    );
  }

  updateOrganizationPages(data: any): Observable<any> {
    return this.http.put(
      `${this.baseUri}/pages/active/${this.orgId}/${data.id}`,
      { ...data }
    );
  }

  disconnectOrganizationPage(pageId: any): Observable<any> {
    return this.http.delete(
      `${this.baseUri}/pages/setup/disconnect/${this.orgId}`
    );
  }

fetchOrganizationPagePosts(pageId: any, page: number, population: number): Observable<any> {
  return this.http.get(
    `${this.baseUri}/feeds/read/filter?orgId=${this.orgId}&pageId=${pageId}&page=${page}&population=${population}`
  );
}

  fetchOrganizationPageAnalytics(pageId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/pages/analytics/${this.orgId}/${pageId}`
    );
  }

  fetchFacebookPost(pageId: any, postId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/pages/facebook-post/${this.orgId}/${pageId}/${postId}`
    );
  }

  replyComment(data: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/response/comment`, {
      ...data,
      org_id: this.orgId,
      reply_by_id: this.userId,
      reply_by_name: this.userName,
      reply_by_role: this.userRole,
    });
  }

  replyPost(data: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/response/post`, {
      ...data,
      org_id: this.orgId,
      reply_by_id: this.userId,
      reply_by_name: this.userName,
      reply_by_role: this.userRole,
    });
  }

  deleteComment(id: any): Observable<any> {
    return this.http.delete(
      `${this.baseUri}/pages/response/${this.orgId}/comment/${id}`
    );
  }

  deleteReplyResponse(commentId: any): Observable<any> {
    return this.http.post(
      `${this.baseUri}/pages/response/${this.orgId}/comment/${commentId}/unsend-reply`,
      {
        deleted_by: this.userName,
        deleted_by_role: this.userRole,
        deleted_by_id: this.userId,
      }
    );
  }

  likeComment(commentId: string): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/response/comment/like`, {
      commentId,
      org_id: this.orgId,
    });
  }

  unlikeComment(commentId: string): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/response/comment/unlike`, {
      commentId,
      org_id: this.orgId,
    });
  }
}
